export var MetricTrend;
(function (MetricTrend) {
    MetricTrend["POSITIVE"] = "positive";
    MetricTrend["NEGATIVE"] = "negative";
})(MetricTrend || (MetricTrend = {}));
export var ContextComparisonMode;
(function (ContextComparisonMode) {
    ContextComparisonMode["None"] = "none";
    ContextComparisonMode["Segment"] = "segment";
    ContextComparisonMode["Device"] = "device";
    ContextComparisonMode["Period"] = "period";
})(ContextComparisonMode || (ContextComparisonMode = {}));
export var ContextComparisonModeV2;
(function (ContextComparisonModeV2) {
    ContextComparisonModeV2["Segment"] = "segment";
    ContextComparisonModeV2["Device"] = "device";
    ContextComparisonModeV2["Period"] = "period";
})(ContextComparisonModeV2 || (ContextComparisonModeV2 = {}));
//# sourceMappingURL=context.model.js.map